import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteExpenseCategoryMutation($input: DeleteExpenseCategoryInput!) {
		deleteExpenseCategory(input: $input) {
			deletedExpenseCategoryId
		}
	}
`;

function getConfigs(companyId) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: companyId,
			connectionKeys: [
				{
					key: 'Company_expenseCategories',
				},
			],
			pathToConnection: ['company', 'expenseCategory'],
			deletedIDFieldName: 'deletedExpenseCategoryId',
		},
	];
}

function getOptimisticResponse(input) {
	return {
		deleteExpenseCategory: {
			deletedExpenseCategoryId: input.id,
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('ExpenseCategory Deleted');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), id: input.id}},
		configs: getConfigs(input.companyId),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
